import { render, staticRenderFns } from "./register_验证码版本.vue?vue&type=template&id=c26c7750&scoped=true"
import script from "./register_验证码版本.vue?vue&type=script&lang=js"
export * from "./register_验证码版本.vue?vue&type=script&lang=js"
import style0 from "./register_验证码版本.vue?vue&type=style&index=0&id=c26c7750&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c26c7750",
  null
  
)

export default component.exports